module.exports = __webpack_public_path__ + "img/logo-linkedin.777b7cb5.svg";